import React from "react";
import PropTypes from "prop-types";
import ActionLogger from "action-logger";
import ProductCarousel from "../shared/carousels/product-carousel";
import { userDataPropType, productPropType } from "components/propTypes";
import { pageTypes, analytics } from "rtr-constants";
import ProductImageRotation from "helpers/product-image-rotation";
import MaternityHelper from "helpers/maternity-helper";
import { discoArrayToProductImageStruct } from "helpers/product-image-helpers";

class PDPOutfitStyles extends React.Component {
  static propTypes = {
    annotationSuffix: PropTypes.string,
    closeModal: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    filters: PropTypes.object,
    isRentable: PropTypes.bool,
    isAccessory: PropTypes.bool,
    productId: PropTypes.string,
    product: productPropType,
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    shortlists: PropTypes.arrayOf(PropTypes.object),
    staticLogProperties: PropTypes.object,
    title: PropTypes.string.isRequired,
    type: PropTypes.string,
    userData: userDataPropType,
    noModelImageFirst: PropTypes.bool,
    staticProduct: PropTypes.object,
    isUPDP: PropTypes.bool,
  };

  static defaultProps = {
    staticLogProperties: {
      object_type: "node",
      module_type: "pdp_carousel",
      pageType: pageTypes.PDP,
    },
  };

  componentDidMount() {
    const { label, pdp_style, all_products } = this.commonLogProperties();
    const userId = this.props.userData?.userProfile?.id;
    if (this.props.products?.length) {
      ActionLogger.logAction({
        object_type: analytics.OBJECT_TYPE.PDP_CAROUSEL,
        action: analytics.ACTION_TYPE.VIEW,
        user_id: userId,
        carousel: label,
        style_name: pdp_style,
        products: all_products,
      });
    }
  }

  commonLogProperties() {
    const { products = [], title, staticLogProperties, productId } = this.props;
    // changes display name to underscore separated string, e.g. 'You may also like' to 'you_may_also_like'
    const label = title.replace(/\s+/g, "_").toLowerCase();
    const all_products = JSON.stringify(products.map(product => product?.id));
    return {
      ...staticLogProperties,
      label,
      pdp_style: productId,
      all_products,
    };
  }

  extraPixelData() {
    return {
      action: "click_item",
      nthStyleRequired: true,
      ...this.commonLogProperties(),
    };
  }

  logStylesInView = (styleNames, carousel, index, previousIndex, newIndex) => {
    const movingRight = newIndex - previousIndex > 0;
    const filteredStyleNames = styleNames.filter(styleName => !!styleName);
    const dataToLog = {
      action: "visible_products",
      products: JSON.stringify(filteredStyleNames),
      ...this.commonLogProperties(),
    };

    if (movingRight) {
      ActionLogger.logAction(dataToLog);
    }
  };

  filteredSizes = () => {
    return this.props.filters?.canonicalSizes || [];
  };

  render() {
    if (!this.props.isRentable || !this.props.products?.length) {
      return null;
    }
    const { isAccessory, products, product, staticProduct, isUPDP } = this.props;
    const productData = isUPDP ? staticProduct : product;
    const filteredSizes = this.filteredSizes();

    const showMaternityBumpImage = MaternityHelper.showMaternityBumpImage(this.props.userData);
    const imageRotation = ProductImageRotation(filteredSizes, productData, showMaternityBumpImage);
    const frontImgType = imageRotation.find(imgType => imgType.toLowerCase().includes("front")); // catches other types of front images such as "frontPlus" or "bumpFront"

    const productImages = isUPDP ? discoArrayToProductImageStruct(staticProduct.images) : productData?.images;

    // creating a fake product item that just displays the outfit as a tile inside a pdp products carousel
    // don't love this apporoach but because this carousel is built as a HOC in product-interface.jsx, its simpler to do it this way
    const newProductsArr = [
      ...(!isAccessory && productImages?.[frontImgType]
        ? [
            {
              hideRatingsActions: true,
              isProductDrawerEnabled: false,
              hideProductInfo: true,
              displayName: productData?.displayName,
              designer: { displayName: productData?.designerDisplayName ?? productData?.designer?.displayName },
              images: { front: productImages[frontImgType] },
            },
          ]
        : []),
      ...(isAccessory && productImages?.top
        ? [
            {
              hideRatingsActions: true,
              isProductDrawerEnabled: false,
              hideProductInfo: true,
              displayName: productData?.displayName,
              designer: { displayName: productData?.designerDisplayName ?? productData?.designer?.displayName },
              images: { top: productImages?.top },
            },
          ]
        : []),
      ...products,
    ];

    return (
      <div className="pdp-carousel carousel-with-title">
        <h2 className="h3 carousel-header">{this.props.title}</h2>
        <div className="pdp-carousel__products how_we_styled_it">
          <ProductCarousel
            annotationSuffix={this.props.annotationSuffix}
            closeModal={this.props.closeModal}
            customHeartLoggingOptions={this.commonLogProperties()}
            dispatch={this.props.dispatch}
            extraPixelData={this.extraPixelData()}
            filters={this.props.filters}
            isPdpCarousel={true}
            isRentable={this.props.isRentable}
            isFullBleedCarousel={true}
            isPeekCarousel={true}
            type={this.props.type}
            logStylesInView={this.logStylesInView}
            products={newProductsArr}
            shortlists={this.props.shortlists}
            userData={this.props.userData}
            noModelImageFirst={this.props.noModelImageFirst}
          />
        </div>
      </div>
    );
  }
}

export default PDPOutfitStyles;
